import { FormGroup } from '@angular/forms';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FlexibleConfig} from '../../../../core/interfaces/flexible-config';
import {FormMode} from '../../../../core/constants/form-mode';
import { ModalityModel } from 'src/app/_models/ImagingProject/modality-model';
import { ReadingVersion } from 'src/app/core/constants/reading-version';

import {FormControl, Validators, AbstractControl, ValidationErrors, } from '@angular/forms';
import {ImagingProjectReadingBasicComponent} from '../../imaging-project-reading-basic.component';
import {MatDialog} from '@angular/material/dialog';
import {SequenceLabelModel} from '../../../../_models/ImagingProject/sequence-label-model';
import {BatchConfigModel} from '../../../../_models/BatchLogic/batch-config-model';
import {AutoBatchConfigPayload} from '../../../../core/payload/auto-batch-config-payload';
import {
    defaultBasicAutoBatchConfig, ImagingProjectSubmitEvent
} from '../imaging-project-reading-selector/imaging-project-reading-selector.component';
import {
    AutoCreationBatchConfigDialogComponent
} from '../../../../components/controls/auto-creation-batch-config-dialog/auto-creation-batch-config-dialog.component';
import {ReadingType} from '../../../../core/constants/reading-type';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute} from '@angular/router';
import {StudySequenceLabelService, StudyService, StudyUserService} from '../../../../_services';
import {VisitType} from '../../../../_models/ImagingProject/patient-model';
import * as moment from 'moment';
import {forkJoin} from 'rxjs';
import {BatchLogicService} from '../../../../_services/batch-logic.service';
import { VisitModalityConfiguratorDialogComponent } from '../visit-modality-configurator-dialog/visit-modality-configurator-dialog.component';
import {BrainSafetyConfigModel} from '../../../../_models/ImagingProject/BRAIN-SAFETY/brain-safety-config-model';


@Component({
    selector: 'app-imaging-project-reading-brain-safety',
    templateUrl: 'imaging-project-reading-brain-safety.component.html',
    styleUrls: ['imaging-project-reading-brain-safety.component.css']
})
export class ImagingProjectReadingBrainSafetyComponent implements OnInit {
    // @Inputs and @Outputs
    @Input('configModel')
    set configModel(value: any) {
        if (value != null) {
            this.configForm.patchValue(value);
        }
    }
    get configModel(): any {
        return this.configForm;
    }
    @Input() selectedConfig: FlexibleConfig<BrainSafetyConfigModel>;
    @Input() public mode: FormMode;
    @Output() public clickCancel = new EventEmitter<any>();
    @Output() public clickSubmit = new EventEmitter<any>();
    // end @Inputs and @Outputs

    // Models and Variables
    readonly formModes = FormMode;
    readonly EARLY_TERMINATION_VISIT = 'Early Termination';
    studyId: number;
    configForm: FormGroup = new FormGroup({
        endpointReadingVersion: new FormControl('basic'),
        modalities: new FormControl([], [Validators.required]),
        readingLevel: new FormControl('visit', [Validators.required]),
        readingType: new FormControl('parallel', [Validators.required]),
        hideVisitHistory: new FormControl('hide_scan_dates', [Validators.required]),
        readers: new FormControl([], [Validators.required]),
        readingVersion: new FormControl(ReadingVersion.BRAIN_SAFETY, [Validators.required]),
        batchManagement: new FormControl(false, [Validators.required, this.batchManagementValidator]),
        imageViewerConfiguration: new FormControl('eCRF_Only'),
        endpoint: new FormControl(null),
        anatomySelector: new FormControl([], [Validators.required]),
        visit: new FormControl([])
    });

    modalities: ModalityModel[];

    basicBatchConfig: any;
    batchManagementType = false;

    selectedReadersids = [];
    readers: any[] = [];
    minReaders = 1;
    maxReaders = 20;

    dataSourceReaders: any;
    displayedReadersColumns: string[] = ['id', 'userName', 'email', 'actionDelete'];
    selectedReaders = [];

    // formValid = false;

    studyVisits: any[] = [];
    unscheduledAllowed: boolean;
    eligibilityVersion = false;
    simpleReadVersion = false;
    // end Models and Variables

    anatomySelectorControl = new FormControl(null, [Validators.required]);
    availableSequenceLabels: SequenceLabelModel[] = [];
    selectedSequenceLabels: SequenceLabelModel[] = [];
    studySequenceLabels: SequenceLabelModel[] = [];
    readersField = new FormControl('', [
        Validators.required
    ]);

    constructor(private dialog: MatDialog,
                private activatedRoute: ActivatedRoute,
                private studySequenceLabelService: StudySequenceLabelService,
                private studyUserService: StudyUserService,
                private studyService: StudyService,
                private batchLogicService: BatchLogicService) { }

    ngOnInit(): void {
        // this.formValid = false;
        this.selectedReaders = [];
        this.configForm.get('readers').value.forEach(ri => {
            this.selectedReadersids.push(ri['id']);
        });

        this.studyId = parseInt(this.activatedRoute.snapshot.params.id, 10);

        const serviceCalls = [
            this.studySequenceLabelService.getGroupedStudyModalitiesByStudyId(this.studyId),
            this.studyUserService.getReadersByStudyId(this.studyId),
            this.studyService.getVisitsByStudyId(this.studyId),
            this.studySequenceLabelService.getSequenceLabelsByStudyId(this.studyId),
            this.studyService.getById(this.studyId)
        ];
        forkJoin(serviceCalls).subscribe(([modalityResp, readerResp, visitsResp, sequenceLabelResp, studyResp]) => {

            if (modalityResp['data'] != null) {
                this.modalities = modalityResp['data'];
                this.modalities.sort((a, b) => a.name.localeCompare(b.name));
                if (this.mode === FormMode.EDIT) {
                    this.configForm.get('modalities').setValue(modalityResp['data'].filter(x => this.configForm.get('modalities').value.find(m => m.name === x.name)));
                } else {
                    this.configForm.get('modalities').setValue(this.modalities);
                }
            }

            if (readerResp['responseCode'] === 200) {
                this.readers = readerResp['data'];
                const activeReader: any[] = [];
                this.readers.forEach(r => {
                    if (this.selectedReadersids.includes(r.id)) {
                        activeReader.push(r);
                    }
                });
                this.configForm.get('readers').setValue(activeReader);
                this.dataSourceReaders = this.configForm.get('readers').value;
                this.selectedReaders = this.configForm.get('readers').value;
                this.selectedReadersids = [];
                this.configForm.get('readers').value.forEach(r => {
                    const cur = this.readers.indexOf(r);
                    this.readers.splice(cur, 1);
                });
            }


            this.studyVisits = [...visitsResp['data']];
            this.initStudyVisits(studyResp['data']);
            if (this.mode === FormMode.NEW) {
                this.addVisitsToConfigForm();
            }

            this.prepareSequenceLabels(sequenceLabelResp);
        });
        this.onChangeReadingVersion(false);
        this.loadBatchConfigs();
    }

    loadBatchConfigs(): void {
        if (this.mode === FormMode.EDIT) {
            this.batchLogicService.getBatchConfigsForReadingConfig(this.studyId, this.selectedConfig.id).subscribe(response => {
                const batchConfigs = response.data;
                batchConfigs.forEach(c => {
                    this.basicBatchConfig = c;
                });
            });
        }
    }

    onChangeReadingVersion(fromUser: boolean = true) {
        this.simpleReadVersion = this.configForm.get('readingVersion').value === ReadingVersion.BRAIN_SAFETY;
        if (fromUser === false) {
            return;
        }
        this.prepareSequenceLabels(this.modalities);
        this.addVisitsToConfigForm();
    }

    openModalitiesDialog() {
        ImagingProjectReadingBasicComponent.clearFocus();

        const dialogRef = this.dialog.open(VisitModalityConfiguratorDialogComponent, {
            data: {
                visits: this.configForm.get('visit').value,
                modalities: this.modalities,
                unscheduledAllowed: this.unscheduledAllowed
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
                this.filterVisits(result.visits);
                const uniqueModality = this.getAllVisitsUniqueModalities(result.visits);
                this.configForm.get('modalities').setValue(uniqueModality);
                this.initDefaultSequenceLabels(this.configForm.get('modalities').value);
            }
        });
    }

    private filterVisits(visits) {
        visits.forEach(visit => {
            if (!visit.modalities || visit.modalities.length < 1) {
                this.studyVisits.find(v => (v.id === visit.id) || (!v.id && v.name === visit.name)).isAvailable = false;
            } else {
                this.studyVisits.find(v => (v.id === visit.id) || (!v.id && v.name === visit.name)).isAvailable = true;
            }
        });
    }

    getAllVisitsUniqueModalities(visits: any[]) {
        let modalities = [];
        visits.forEach((visit, visitIndex) => {

            const visitTemp = this.configForm.get('visit').value;
            visitTemp[visitIndex].modalities = [...visit.modalities];
            this.configForm.get('visit').setValue(visitTemp);

            modalities = [...modalities, ...visit.modalities];
        });
        const uniqueModality = [];
        modalities.forEach((modality) => {
            const index = uniqueModality.findIndex((m) => m.id === modality.id) === -1;
            if (index) { uniqueModality.push(modality); }
        });
        return uniqueModality;
    }

    initStudyVisits(study: any) {
        // sort study visits by id
        this.studyVisits = this.sortVisits(this.studyVisits);
        this.unscheduledAllowed = study.unscheduledAllowed;
        // add unschaduled visits and early termination
        const unscheduled: any = new (class implements Object {
            id?: number;
            created?: number;
            name: string;
            type?: VisitType;
            durationTimeUnit?: string;
            durationTimeValue?: number;
            baseline?: boolean;
            repeatAllowed?: boolean;
            modalities?: ModalityModel[];
            isAvailable = true;
        })();
        unscheduled.name = 'Unscheduled';
        unscheduled.type = VisitType.UNSCHEDULED_REGULAR;
        this.studyVisits.push(unscheduled);

        const earlyTermination: any = new (class implements Object {
            id?: number;
            created?: number;
            name: string;
            type?: VisitType;
            durationTimeUnit?: string;
            durationTimeValue?: number;
            baseline?: boolean;
            repeatAllowed?: boolean;
            modalities?: ModalityModel[];
            isAvailable = true;
        })();
        earlyTermination.name = this.EARLY_TERMINATION_VISIT;
        earlyTermination.type = VisitType.UNSCHEDULED_EARLY_TERMINATION;
        this.studyVisits.forEach(visit => visit.isAvailable = true);
        this.studyVisits.push(earlyTermination);

        if (this.mode !== FormMode.EDIT) {
            this.configForm.get('visit').setValue(this.studyVisits);
            this.configForm.get('visit').value.forEach(v => v['modalities'] = !this.unscheduledAllowed && v.type === VisitType.UNSCHEDULED_REGULAR ? [] : this.modalities);
        }
    }

    sortVisits(visits) {
        visits.forEach(visit => {
            let visitDate = moment(visit.create);
            if (visit.durationTimeUnit === 'D') {
                visitDate = moment(visit.create).add(visit.durationTimeValue, 'd');
            } else if (visit.durationTimeUnit === 'W') {
                visitDate = moment(visit.create).add(visit.durationTimeValue, 'w');
            } else if (visit.durationTimeUnit === 'M') {
                visitDate = moment(visit.create).add(visit.durationTimeValue, 'M');
            }
            visit.visitDate = visitDate;
        });
        visits.sort((a, b) => {
            if (a.visitDate < b.visitDate) {
                return -1;
            }
            if (a.visitDate > b.visitDate) {
                return 1;
            }
            return 0;
        });
        const baselineIndex = visits.indexOf(visits.find(this.isBaseline));
        visits.unshift(visits.find(this.isBaseline));
        visits.splice(baselineIndex + 1, 1);
        return visits;
    }
    isBaseline(visit) {
        return visit.baseline === true;
    }

    addVisitsToConfigForm() {
        const visitTemp = [];
        this.getModifiedVisit().forEach(visit => {
            visit.modalities = !this.unscheduledAllowed && visit.type === VisitType.UNSCHEDULED_REGULAR ? [] : this.modalities;
            visitTemp.push(visit);
        });
        this.configForm.get('visit').setValue(visitTemp);
    }

    getModifiedVisit() {
        return this.studyVisits.filter(v => v.type !== VisitType.UNSCHEDULED_REGULAR || this.unscheduledAllowed);
    }
    // end Visit and modality configuration

    // Sequence Label
    prepareSequenceLabels(sequenceLabelResp) {
        this.studySequenceLabels = sequenceLabelResp.data;
        if (this.mode === FormMode.EDIT) {
            if (!!this.configForm.get('anatomySelector').value) {
                this.initSequenceLabels(this.configForm.get('anatomySelector').value);
            } else {
                this.initDefaultSequenceLabels(this.modalities);
            }
        } else if (this.mode === FormMode.NEW) {
            this.initDefaultSequenceLabels(this.modalities);
        }
    }

    initDefaultSequenceLabels(modalities: ModalityModel[]) {
        this.availableSequenceLabels = this.getAvailableSequenceLabels(modalities);
        this.selectSequenceLabels(this.availableSequenceLabels);
    }

    selectSequenceLabels(sequences: SequenceLabelModel[]) {
        this.selectedSequenceLabels = sequences;
        this.configForm.get('anatomySelector').setValue(sequences);
    }

    initSequenceLabels(sequenceLabels: { id: number }[]) {
        const modalities = this.modalities.filter(m => this.selectedConfig.config.modalities.find(cm => cm.name === m.name));
        this.availableSequenceLabels = this.getAvailableSequenceLabels(modalities);
        this.selectedSequenceLabels = this.studySequenceLabels
            .filter(label => sequenceLabels.find(targetLabel => label.id === targetLabel.id));
    }

    getAvailableSequenceLabels(modalities): SequenceLabelModel[] {
        const configLabels: Set<SequenceLabelModel> = new Set<SequenceLabelModel>();
        for (const m of modalities) {
            for (const label of m.sequenceLabels) {
                configLabels.add(label);
            }
        }
        return Array.from(configLabels);
    }
    // end Sequence Label

    // Batch management and config
    get batchManagementValidator() {
        return (control: AbstractControl): ValidationErrors | null => {
            return control.value === true && ((!!this.basicBatchConfig && !this.basicBatchConfig?.numberOfReadings) || !this.basicBatchConfig)
                ? {norError: 'Number of readings is required'} : null;
        };
    }

    onBatchManagementSelected(): void {
        if (this.basicBatchConfig) {
            this.basicBatchConfig.numberOfReadings = null;
            this.configForm.get('batchManagement').updateValueAndValidity();
        }
    }

    openAutoCreationBatchConfigDialog(config: BatchConfigModel): void {
        let inputConfig = config as AutoBatchConfigPayload;
        const val = this.configForm.get('batchManagement').value;
        if (!val) {
            inputConfig = {...defaultBasicAutoBatchConfig};
        } else {
            inputConfig = this.basicBatchConfig ? { ...this.basicBatchConfig } : null;
        }

        const dialogRef = this.dialog.open(AutoCreationBatchConfigDialogComponent, {
            width: '500px',
            data: {
                reading: 'BrainSafety',
                readingType: ReadingType.BASIC_READING,
                configInput: inputConfig,
                readonlyDialog: !val
            }
        });

        dialogRef.afterClosed().subscribe((result: BatchConfigModel) => {
            if (result) {
                this.basicBatchConfig = {...result};
                this.configForm.get('batchManagement').updateValueAndValidity();
            }
            ImagingProjectReadingBasicComponent.clearFocus();
        });
    }
    // end Batch management and config

    // Readers
    onReaderSelectionChange(event: { value: any[]; }) {
        this.selectedReadersids = event.value;
    }

    onAddSelectedReaders() {
        if (this.selectedReadersids != null) {
            let counter = this.configForm.get('readers').value.length;
            this.selectedReadersids.forEach(readerId => {
                if (counter < this.maxReaders) {
                    const reader = this.readers.find(r => r.id === readerId);
                    if ((reader != null) && (!this.configForm.get('readers').value.includes(reader))) {

                        const visitTemp = this.configForm.get('readers').value;
                        visitTemp.push(reader);
                        this.configForm.get('readers').setValue(visitTemp);

                        const index = this.readers.indexOf(reader);
                        this.readers.splice(index, 1);
                    }
                    counter += 1;
                }
            });

            this.selectedReadersids = [];
        }
        this.dataSourceReaders = new MatTableDataSource<any>(this.configForm.get('readers').value);
        this.selectedReaders = this.configForm.get('readers').value;
        if (this.configForm.get('readers').value.length > 0) {
            this.readersField.clearValidators();
        }
    }

    deleteReader(reader: any) {
        const index = this.configForm.get('readers').value.indexOf(reader);
        this.configForm.get('readers').value.splice(index, 1);
        this.dataSourceReaders = new MatTableDataSource<any>(this.configForm.get('readers').value);
        this.selectedReadersids = this.configForm.get('readers').value;
        this.readers.unshift(reader);
        this.selectedReadersids = [];

        if (this.configForm.get('readers').value.length === 0) {
            this.readersField.validator = Validators.required;
        }
    }
    // end Readers

    clickSubmitBtn() {
        const readers = [];
        this.configForm.get('readers').value.forEach(r => {
            readers.push({id: r.id});
        });

        this.configForm.get('anatomySelector').setValue(this.selectedSequenceLabels.map(l => {
            return {id: l.id};
        }));
        this.configForm['endpointReadingVersion'] = 'basic';
        this.configForm.get('readers').setValue(readers);
        if (!this.basicBatchConfig) {
            this.basicBatchConfig = {
                batchCount: '1',
                endpoint: 'BRAINSAFETY',
                flexibleConfigId: null,
                id: null,
                initiationMethod: 'auto',
                initiationOption: 'by_quantity',
                numberOfReadings: 1,
                readingType: 'basic_reading',
                studyId: this.studyId
            };
        }
        const submitEvent: ImagingProjectSubmitEvent = {
            result: 'submit',
            data: this.configForm.value,
            basicBatchConfig: this.basicBatchConfig
        };

        this.clickSubmit.emit(submitEvent);
    }

    clickCancelBtn() {
        this.clickCancel.emit({result: 'cancel'});
    }
}
